module.exports = __webpack_public_path__ + "static/media/enfant-avatar.9664acf5.jpg";